module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraBold.0a9c473.woff2";